import React, { useState } from 'react'
import { Form, Input, notification } from 'antd'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import cyprusFamTour2025Img from '../cyprusFamTour/images/cyprusFamTour2025_2.jpg'
import InputBox from '../../components/_utils/InputBox'
import { interestForCyprusFamTourAppFxn } from '../cyprusFamTour/action'
import { useDispatch } from 'react-redux'

let { TextArea } = Input
let initState = {
  name: '',
  email: '',
  mobile: '',
  position: '',
  website: '',
  details: ''
}
const CyprusFamTour2025 = () => {
  let dispatch = useDispatch()
  let [state, setState] = useState(initState)
  const events = {
    _updateState: (data) => {
      setState((prevState) => {
        return {
          ...prevState,
          ...data
        }
      })
    },
    handleSubmit: async () => {
      if (!state.name) {
        return notification.warning({ message: 'Enter Name of Representative.' })
      }
      if (!state.email) {
        return notification.warning({ message: 'Enter Email Address (You used to access Unizportal to log in)' })
      }
      if (!state.mobile) {
        return notification.warning({ message: 'Enter Your Contact Details' })
      }
      if (!state.position) {
        return notification.warning({ message: 'Enter Position At Your Company' })
      }
      let resp = await dispatch(interestForCyprusFamTourAppFxn(state))
      if (resp && resp.success) {
        events._updateState({ ...initState })
      }
    }
  }
  return (
    <>
      <React.Fragment>
        <section className='banner blog-banner'></section>


        <section className='contact-form' style={{ position: 'relative' }}>
          <div className='container'>
            <div className={'fam-tour-block-2'}>
              <div className='row'>

                <div className='col-lg-6'>
                  <div className={'img-box'}>
                    <LazyLoadImage src={cyprusFamTour2025Img} />
                  </div>
                </div>
                <div className='col-lg-6'>
                  <div className='box'>
                    <h5>
                      Please complete the information below to express interest in the Cypurs Fam Tour in 2025.
                    </h5>

                    <div className={'row'}>
                      <div className={'col-md-12'}>
                        <InputBox title={'Name of Representative *'}>
                          <Input type='text' className='form-control'
                                 name={'Name'} value={state.name}
                                 placeholder={'Enter Name of Representative'}
                                 onChange={({ target }) => events._updateState({ name: target.value })} />
                        </InputBox>
                      </div>
                      <div className={'col-md-12'}>
                        <InputBox title={'Email Address (You used to access Unizportal to log in) *'}>
                          <Input type='text' className='form-control'
                                 placeholder={'Enter Email Address (You used to access Unizportal to log in)'}
                                 name={'Email'} value={state.email}
                                 onChange={({ target }) => events._updateState({ email: target.value })} />
                        </InputBox>
                      </div>

                      <div className={'col-md-12'}>
                        <InputBox title={'Your Contact Details *'}>
                          <Input type='text' className='form-control'
                                 name={'MobileNo'} value={state.mobile}
                                 placeholder={'Enter Your Contact Details'}
                                 onChange={({ target }) => events._updateState({ mobile: target.value })} />
                        </InputBox>
                      </div>
                      <div className={'col-md-12'}>
                        <InputBox title={'Position At Your Company *'}>
                          <Input type='text' className='form-control'
                                 name={'position'} value={state.position}
                                 placeholder={'Enter Position At Your Company'}
                                 onChange={({ target }) => events._updateState({ position: target.value })} />
                        </InputBox>
                      </div>
                      <div className={'col-md-12'}>
                        <InputBox title={'Website of the company'}>
                          <TextArea
                            placeholder={'Enter Website of the company'}
                            className='form-control'
                            name={'website'} value={state.website}
                            rows={5}
                            onChange={({ target }) => events._updateState({ website: target.value })} />
                        </InputBox>
                      </div>
                    </div>

                    <div className={'align-center mt30'}>
                      <a className={'btn btn-primary btn-block lg'} onClick={events.handleSubmit}>Submit
                      </a>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </section>


      </React.Fragment>

    </>
  )
}
export default CyprusFamTour2025
